import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';

export interface JcTimePickerProps extends JcCommonProps {
    readonly value: string; // Time in 24-hour format (HH:mm)
    readonly onChange: (value: string) => void;
    readonly min?: string; // Minimum time in HH:mm format
    readonly max?: string; // Maximum time in HH:mm format
    readonly disabled?: boolean;
    /** Accessible name for use outside a labelling JcField. */
    readonly ariaLabel?: string;
}

export const JcTimePicker: React.FunctionComponent<JcTimePickerProps> = (props: JcTimePickerProps) => {
    const id = useJcFieldId(props.id);
    const commonProps = JcUtils.commonProps({ ...props, id }, ["jc-input", "jc-timepicker"]);

    return (
        <input
            {...commonProps}
            aria-label={props.ariaLabel}
            type="time"
            value={props.value}
            min={props.min}
            max={props.max}
            disabled={props.disabled}
            onChange={e => props.onChange(e.target.value)}
        />
    );
};
